import React from "react";
import cx from "classnames";
import "./Sidebar.css";

import { importImage } from "lib/legacy";
import { Link } from "react-router-dom";

const OverviewIcon = importImage("Overview.svg");
const PositionIcon = importImage("Position.svg");
const OrderIcon = importImage("Orders.svg");
const HistoryIcon = importImage("History.svg");

const Sidebar = ({ setActivePage, activePage }) => {
  const handleSetActivePage = (page) => {
    setActivePage(page);
  };

  return (
    <div className="Sidebar page-layout">
      <span className="SidebarHeader text-inactive">User Portfolio</span>
      <div className="SidebarItems">
        <div
          className={cx("SidebarItem", {
            active: activePage === "overview",
          })}
          onClick={() => handleSetActivePage("overview")}
        >
          <img src={OverviewIcon} alt="Overview" className="Sidebaricons" />
          <span>Overview</span>
        </div>
        <div
          className={cx("SidebarItem", {
            active: activePage === "position",
          })}
          onClick={() => handleSetActivePage("position")}
        >
          <img src={PositionIcon} alt="Position" className="Sidebaricons" />
          <span>Position</span>
        </div>
        <div
          className={cx("SidebarItem", {
            active: activePage === "orders",
          })}
          onClick={() => handleSetActivePage("orders")}
        >
          <img src={OrderIcon} alt="Orders" className="Sidebaricons" />
          <span>Orders</span>
        </div>
        <div
          className={cx("SidebarItem", {
            active: activePage === "history",
          })}
          onClick={() => handleSetActivePage("history")}
        >
          <img src={HistoryIcon} alt="History" className="Sidebaricons" />
          <span>History</span>
        </div>
      </div>
      <div className="SidebarBuy">
        <Link to="/buy">
          <button className="SidebarBuyButton transition-effect">Buy PLP</button>
        </Link>
        <Link to="/buy">
          <button className="SidebarBuyButton transition-effect">Buy PALM</button>
        </Link>
      </div>
    </div>
  );
};

export default Sidebar;
